export const CONNECT_DEVICE = 1;
export const SELECT_PAYLOAD = 2;
export const RUN_EXPLOIT = 3;
